import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import MultiStepFormContext from "~/contexts/MultiSelectForm/MultiSelectFormContext";
import Button from "~/shared/Btn";
import TextareaInput from "~/shared/TextareaInput";
import NumberInput from "~/shared/NumberInput";
import { Content, Header, Footer } from "../styles";
import { Row, Col } from "react-bootstrap";

type CorporateProps = {
    prevStep?: () => void;
    nextStep?: () => void;
    goToStep?: (step: number) => void;
    currentStep: number;
};

const extraFields = {
    number_person: {
        name: "Numero de Pessoas",
        value: "",
        type: "numero",
    },
    number_photo_per_person: {
        name: "Numero de fotos por pessoa",
        value: "",
        type: "numero",
    },
    adicional_info: {
        name: "Informações adicionais",
        value: "",
        type: "texto",
    },
};

const Corporate = ({ nextStep, goToStep }: CorporateProps) => {
    const { values, confirmationStep, handleChange, setValues, updateValuesInLocalStorage } =
        useContext(MultiStepFormContext);

    const [addicionalInfo, setAddicionalInfo] = useState<string>(values?.extra?.adicional_info?.value || "");
    const [personNumber, setPersonNumber] = useState<string>(values?.extra?.number_person?.value || "");
    const [photosPerPerson, setPhotosPerPerson] = useState<string>(values?.extra?.number_photo_per_person?.value || "");

    const briefing = `Informações\nNúmero de pessoas para fotografar: ${
        values?.extra?.number_person?.value || personNumber
    }\nQuantidade de fotos por pessoa: ${values?.extra?.number_photo_per_person?.value || photosPerPerson}`;

    const validateAndNextStep = () => {
        if (!personNumber.length || !photosPerPerson.length) {
            return toast.error("Número de pessoas e quantidade de fotos por pessoa são obrigatórios!");
        }

        if (confirmationStep) {
            updateValuesInLocalStorage();
            return goToStep(confirmationStep);
        }

        return nextStep();
    };

    const handleExtraFieldChange = async (name: string, value: any) => {
        if (Object.keys(extraFields).includes(name)) {
            handleChange(name, { ...extraFields[name], value, type: extraFields[name].type }, { extra: true });
        }
    };

    useEffect(() => {
        const localValues = JSON.parse(localStorage.getItem("values"));
        if (confirmationStep) {
            setValues(localValues);
        }
    }, []);

    useEffect(() => {
        handleChange("briefing", briefing);
    }, [briefing]);

    return (
        <>
            <Header>
                <h1>Defina o briefing do seu job</h1>
                <p>Precisamos de algumas informações para realizar o seu job!</p>
            </Header>

            <Content>
                <div className="title">
                    <p>Informações</p>
                    <div className="bar" />
                    <Row className="input-content">
                        <Col lg={6}>
                            <NumberInput
                                name="number_person"
                                label="Número de pessoas para fotografar"
                                value={personNumber}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setPersonNumber(value);
                                }}
                            />
                        </Col>

                        <Col lg={6}>
                            <NumberInput
                                name="number_photo_per_person"
                                label="Quantidade de fotos por pessoa"
                                value={photosPerPerson}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setPhotosPerPerson(value);
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </Content>
            <Content>
                <div className="title">
                    <p>Informações adicionais</p>
                    <div className="bar" />
                    <TextareaInput
                        name="adicional_info"
                        value={addicionalInfo}
                        placeholder="Descreva aqui qualquer informação adicional..."
                        rows={3}
                        onChange={(name: string, value: string) => {
                            handleExtraFieldChange(name, value);
                            setAddicionalInfo(value);
                        }}
                    />
                </div>
            </Content>

            <Footer>
                {confirmationStep ? (
                    <Button block onClick={validateAndNextStep}>
                        Salvar
                    </Button>
                ) : (
                    <>
                        <Button id="clickSegmentNext" block onClick={() => handleChange("category", 0)}>
                            Voltar
                        </Button>
                        <Button id="clickSegmentNext" block onClick={validateAndNextStep}>
                            Continuar
                        </Button>
                    </>
                )}
            </Footer>
        </>
    );
};

export default Corporate;
